import {Button, Snackbar} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import {Title} from 'components/forms';
import {i18n2} from 'features/i18n/i18n';
import {FastField, Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';
import {LoadIndicator} from 'devextreme-react';

const SignatureDialog = ({
  disableEscape = true,
  openDialog = true,
  onCloseDialog,
  dialogTitle,
  user,
  submit,
  snackbarState,
  onCloseSnackbar = null,
  requireReason = false,
}: {
  disableEscape: boolean;
  openDialog: boolean;
  onCloseDialog: () => void;
  dialogTitle: string;
  user: string;
  submit: any;
  snackbarState: {open: boolean; message: string};
  onCloseSnackbar: any;
  requireReason?: boolean;
}) => {
  const initialValues = requireReason
    ? {pass: '', user: user, reason: ''}
    : {pass: '', user: user};

  return (
    <>
      <Dialog
        disableBackdropClick={disableEscape}
        disableEscapeKeyDown={disableEscape}
        open={openDialog}
        aria-labelledby="7wasdad
                -...,   asdasdqweqegjllñ-alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={onCloseDialog}
      >
        <Title onClose={onCloseDialog} title={dialogTitle} />
        <DialogContent>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, formikFunctions) =>
              submit(values, formikFunctions)
            }
          >
            {(formikProps) => {
              return (
                <Form>
                  <Grid container spacing={2}>
                    {requireReason && (
                      <Grid item sm={12} xs={12} style={{padding: 20}}>
                        <Field
                          label={i18n2._('Reason')}
                          name={'reason'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validate={(value: any) => {
                            let error;
                            if (
                              typeof value !== 'undefined' &&
                              value.length === 0
                            ) {
                              error = i18n2._('Please provide a reason');
                            }
                            return error;
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item sm={6} xs={12} style={{padding: 20}}>
                      <Field
                        label={i18n2._('User')}
                        name={'user'}
                        variant="standard"
                        size="small"
                        fullWidth
                        component={TextField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={true}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12} style={{padding: 20}}>
                      <FastField
                        label={i18n2._('Password')}
                        name={'pass'}
                        variant="standard"
                        size="small"
                        fullWidth
                        component={TextField}
                        type="password"
                        validate={(value: any) => {
                          let error;
                          if (
                            typeof value !== 'undefined' &&
                            value.length === 0
                          ) {
                            error = i18n2._('Please provide a password');
                          }
                          return error;
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    {formikProps.isSubmitting && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                        }}
                      >
                        <LoadIndicator />
                      </div>
                    )}
                  </Grid>
                  <Grid style={{textAlign: 'right'}}>
                    <Button
                      onClick={() => onCloseDialog()}
                      style={{color: 'red'}}
                    >
                      {i18n2._('Cancelar')}
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      autoFocus
                      disabled={formikProps.isSubmitting}
                    >
                      {i18n2._('Firmar')}
                    </Button>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={1000}
        onClose={() => onCloseSnackbar()}
        message={i18n2._(snackbarState.message ? snackbarState.message : '')}
      />
    </>
  );
};

export default SignatureDialog;
